import { BookingLayout } from '@drycut/booking-components';
import { SalonList } from '@drycut/controlled-components';
import { Error404, Loader } from '@drycut/ui-components';
import React from 'react';
import { createBrowserRouter, Outlet } from 'react-router';

import {
  BookingDetailsByUid,
  NewBooking,
  NewPassPurchase,
  PassDetailsByUid,
  Passes,
  PassPurchaseError,
} from './routes';

export default createBrowserRouter([
  {
    element: (
      <BookingLayout src="/images/manual-booking-bg.jpg">
        <React.Suspense fallback={<Loader />}>
          <Outlet />
        </React.Suspense>
      </BookingLayout>
    ),
    children: [
      {
        path: '/:slug',
        element: <NewBooking />,
      },
      {
        path: '/booking/:uid',
        element: <BookingDetailsByUid />,
      },
      {
        path: '/:slug/passes',
        element: <Passes />,
      },
      {
        path: '/:slug/passes/:passId/purchase',
        element: <NewPassPurchase />,
      },
      {
        path: '/:slug/pass/:uid',
        element: <PassDetailsByUid />,
      },
      {
        path: '/passes/payment-error/:transactionId',
        element: <PassPurchaseError />,
      },
    ],
  },
  {
    path: '/',
    element: <SalonList />,
  },
  {
    path: '/not-found',
    element: <Error404 />,
  },
  {
    path: '*',
    element: <Error404 />,
  },
]);
